import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

import { IFBLegalTerm, IFBLegalTermsLocales } from '@interfaces';
import { CompanyService } from '@app/shared/services/company.service';
import { IFBLocalizableResource, IFBUpdateBody } from '@app/models/localizable';

@Injectable({
  providedIn: 'root'
})
export class LegalTermsResource implements IFBLocalizableResource {
  constructor(
    private companyService: CompanyService,
    private http: HttpClient
  ) {}

  private get companyId(): string {
    return this.companyService.data.id;
  }

  private url(companyId: string): string {
    return `https://${environment.API_BASE}/v1/companies/${companyId}/settings/legal_terms`;
  }

  get(locale: string) {
    const params = { locale };
    return this.http.get<IFBLegalTerm>(this.url(this.companyId), { params });
  }

  getLocales() {
    return this.http.get<IFBLegalTermsLocales>(this.url(this.companyId) + '/locales');
  }

  delete(locale: string) {
    return this.http.delete(`${this.url(this.companyId)}/${locale}`);
  }

  update(body: IFBUpdateBody) {
    return this.http.put(this.url(this.companyId), body);
  }

  updateLocales(body: { primary: string }) {
    return this.http.put(`${this.url(this.companyId)}/locales`, body);
  }
}
